export function findOrder<T>(ordered: T[], shapeCode: T) {
    const order = ordered.findIndex((code) => code === shapeCode)

    if (-1 === order) {
        return ordered.length
    }

    return order
}
